import { allOrderListModalAtom, shippingListAtom } from '@/commons/constants';
import { Button, Divider, Modal, Typography } from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';

import * as XLSX from 'xlsx';
import { useEffect, useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { shippingTargetDetail } from '@/interfaces/plan/shipping';
import * as _ from 'lodash';

const ModalWrap = styled.div`
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 90%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .head{
    padding: 0.5rem;
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export default function AllOrderList() {
  const [allOrderListModal, setAllOrderListModal] = useAtom(allOrderListModalAtom);
  const handleClose = () => {
    setAllOrderListModal(false);
  };
  return (
    <Modal open={allOrderListModal} onClose={handleClose}>
      <ModalWrap>
        <div className="head">
          <Typography variant="h5">주문 목록</Typography>
          <CloseIcon onClick={handleClose} />
        </div>
        <Divider />
        <MainContent />
      </ModalWrap>
    </Modal>
  );
}

const MainContentWrap = styled.div`
  width: 100%;
  height: 100%;
  flex-grow:1;
  .body{
    height: calc(100% - 8rem);
    display: flex;
    justify-content: center;
    > div {
      width: 100%;
      padding: 0rem 2rem;
      height: 100%;
    }
`;

const ButtonArea = styled.div`
  width: 100%;
  display:flex;
  justify-content: flex-end;
  padding: 0.5rem 2rem;
`;

const MainContent = () => {
  const { data } = useAtomValue(shippingTargetDetail);
  const shippingList = useAtomValue(shippingListAtom);
  const [contents, setContents] = useState<any[]>();

  const column: GridColDef[] = [
    { field: 'scan_code', headerName: '주문번호', width: 100, headerAlign: 'center' },
    { field: 'plate_number', headerName: '차량', width: 150, headerAlign: 'center', align: 'center' },
    { field: 'customer_nm', headerName: '고객명', flex: 1, headerAlign: 'center' },
    { field: 'address', headerName: '주소', flex: 2, headerAlign: 'center' },
    { field: 'dwell_time', headerName: '체류시간', width: 90, headerAlign: 'center', align: 'center' },
    { field: 'product_name', headerName: '상품명', flex: 1, headerAlign: 'center' },
    { field: 'C', headerName: '수량', width: 80, headerAlign: 'center', align: 'right' },
  ];

  useEffect(() => {
    if (data.orderList && data.orderList.length > 0) {
      let id: number = 0;
      const allDestList: any[] = data.orderList.map((listItem: any, index: number) => {
        const dest = _.find(data.destList, (v) => _.find(v.order_info.list, (ov) => ov === listItem.order_sheet_id));
        return {
          ...listItem,
          plate_number: _.find(shippingList, ['car.car_seq', dest.r_car_seq])?.car.name,
          customer_nm: dest.name,
          address: dest.address,
          dwell_time: dest.dwell_time / 60 + '분',
          id: index,
        };
      });
      setContents(allDestList);
    }
  }, [data]);

  const excelDown = () => {
    if (contents && contents.length > 0) {
      const excelContent = contents.map((dItem: any, dIndex: number) => {
        const retVal = {
          주문번호: dItem.scan_code,
          차량: dItem.plate_number,
          고객명: dItem.customer_nm,
          주소: dItem.address,
          권역: dItem.customer_region,
          체류시간: dItem.dwell_time,
          상품명: dItem.product_name,
          수량: dItem.C,
        };
        return retVal;
      });
      const workSheet = XLSX.utils.json_to_sheet(excelContent);
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, '주문목록');
      XLSX.writeFile(workBook, '주문목록.xlsx');
    }
  };
  return (
    <MainContentWrap>
      <ButtonArea>
        <Button variant="contained" color="success" onClick={excelDown} startIcon={<ExcelIcon />}>
          전체 다운로드
        </Button>
      </ButtonArea>
      <div className="body">
        <div>
          <DataGrid
            disableColumnMenu
            disableColumnResize
            disableRowSelectionOnClick
            columns={column}
            rows={contents && contents.length > 0 ? contents : []}
          />
        </div>
      </div>
    </MainContentWrap>
  );
};

const ExcelIcon = () => {
  return (
    <svg width="1.2rem" height="1.2rem" viewBox="0 0 557 640" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M553.342 636.339H79.2432V3.66138H416.3V145.611H553.342V636.339Z"
        fill="#FCFCFC"
        stroke="#818181"
        stroke-width="10"
        stroke-miterlimit="10"
      />
      <path
        d="M294.483 162.534H27.4363C12.2836 162.534 0 174.828 0 189.994V457.271C0 472.436 12.2836 484.73 27.4363 484.73H294.483C309.635 484.73 321.919 472.436 321.919 457.271V189.994C321.919 174.828 309.635 162.534 294.483 162.534Z"
        fill="#107C42"
      />
      <path d="M256 444H209.788L73 214H120.136L256 444Z" fill="white" />
      <path d="M73 444H119.212L256 214H208.864L73 444Z" fill="white" />
      <path d="M416.3 244.914H338.746V279.33H416.3V244.914Z" fill="#21A365" />
      <path d="M512.144 244.914H434.59V279.33H512.144V244.914Z" fill="#33C481" />
      <path d="M416.3 296.904H338.746V331.321H416.3V296.904Z" fill="#107C42" />
      <path d="M512.144 296.904H434.59V331.321H512.144V296.904Z" fill="#21A365" />
      <path d="M416.3 348.895H338.746V383.312H416.3V348.895Z" fill="#195D38" />
      <path d="M512.144 348.895H434.59V383.312H512.144V348.895Z" fill="#104B2B" />
    </svg>
  );
};
